import styled from 'styled-components';
import { space, width } from 'styled-system';
import PropTypes from 'prop-types';
import React from 'react';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = loader => {
    return new MyUploadAdapter(loader);
  };
}

class MyUploadAdapter {
  constructor(props) {
    // CKEditor 5's FileLoader instance.
    this.loader = props;
    // URL where to send files.
    this.url = '/Services/SaveImage';
  }

  // Starts the upload process.
  upload() {
    return new Promise((resolve, reject) => {
      this.initRequest();
      this.initListeners(resolve, reject);
      this.sendRequest();
    });
  }

  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Example implementation using XMLHttpRequest.
  initRequest() {
    // eslint-disable-next-line no-multi-assign
    const xhr = (this.xhr = new XMLHttpRequest());

    xhr.open('POST', this.url, true);
    xhr.responseType = 'json';
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    // xhr.setRequestHeader('Authorization', getToken());
  }

  // Initializes XMLHttpRequest listeners.
  initListeners(resolve, reject) {
    const { xhr } = this;
    const { loader } = this;
    const genericErrorText = `Couldn't upload file: ${loader.file.name}.`;

    xhr.addEventListener('error', () => reject(genericErrorText));
    xhr.addEventListener('abort', () => reject());
    xhr.addEventListener('load', () => {
      const { response } = xhr;
      if (!response || response.error) {
        return reject(response && response.error ? response.error.message : genericErrorText);
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      resolve({
        default: response.s3Url,
      });
    });

    if (xhr.upload) {
      xhr.upload.addEventListener('progress', evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  sendRequest() {
    const data = new FormData();

    this.loader.file.then(result => {
      data.append('file', result);
      this.xhr.send(data);
    });
  }
}

const StyledEditor = styled(CKEditor)`
  ${space}
  ${width}
  width: 100% !important;
`;

export function EditorControl({ settings, value, name, onChange, onBlur, ...props }) {
  return (
    <StyledEditor
      name={name}
      config={{
        extraPlugins: [MyCustomUploadAdapterPlugin],
      }}
      editor={ClassicEditor}
      data={value}
      onBlur={() => onBlur({ target: { name } })}
      onChange={(event, editor) => {
        onChange({ target: { name, value: editor.getData() } });
        console.log({ event, editor, value });
      }}
      {...props}
    />
  );
}

EditorControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
